import { apiOrigin } from '../../lib/api.ts'

/**
 * Fundos de quadro (SPEC-20261027-1840-biblioteca-de-fundos-e-imagem-do-quadro).
 *
 * Toda imagem de fundo vive no R2 — as que vêm com o Orbind, as que o super
 * admin sobe na biblioteca e as que cada pessoa envia do computador. A tela só
 * recebe o endereço público delas.
 */
export type FundoDaBiblioteca = { id: string; name: string; url: string }

/**
 * Endereço que o navegador carrega para um fundo guardado no quadro.
 *
 * O que a API serve (`/public/...`) ganha a origem da API — em
 * desenvolvimento o site e a API estão em portas diferentes. URL externa
 * (colada pela pessoa) fica como está.
 */
export const urlDoFundo = (url: string) => (url.startsWith('/public/') ? `${apiOrigin()}${url}` : url)

/** Maior imagem aceita no envio do computador. */
export const TAMANHO_MAXIMO_DO_FUNDO = 8 * 1024 * 1024
